import { useCallback, useEffect, useState, createRef, useRef } from 'react'
import { useEffectOnce } from 'usehooks-ts'
import styled from 'styled-components'

const Legend = ({
  tenant,
  colorMode,
  terms,
  colors,
}: {
  tenant?: object
  colorMode?: string
  terms: Array<string>
  colors: Array<string>
}) => {
  const [isMobile, setIsMobile] = useState(false)

  const handleResize = (): void => {
    setIsMobile(window.innerWidth < 600)
  }

  useEffectOnce(() => {
    // set height when window is resized
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  })

  return (
    <>
      <LegendWrapper className={isMobile ? 'mobile' : 'desktop'}>
        {terms.map(function (item: any, itemIndex: number) {
          // console.log('term:', item, colors[itemIndex])
          return (
            <div className='term' key={'item-' + itemIndex}>
              <div
                className='square'
                style={{ backgroundColor: colors[itemIndex] }}
              />
              <div className='label'>{item}</div>
            </div>
          )
        })}
      </LegendWrapper>
    </>
  )
}

const LegendWrapper = styled.div`
  width: 100%;
  margin-bottom: 4rem;
  .term {
    font-size: 1.2rem;
    line-height: 1.6rem;
    display: inline-block;
    margin-right: 1.6rem;
    @media only screen and (min-width: 600px) {
      font-size: 1.35rem;
      margin-right: 2rem;
    }
    .square,
    .label {
      display: inline-block;
    }
    .square {
      height: 10px;
      width: 10px;
      background-color: cyan;
      margin-right: 0.5rem;
      top: 0.1rem;
      position: relative;
      @media only screen and (min-width: 600px) {
        height: 11px;
        width: 11px;
        margin-right: 0.6rem;
      }
  }
`

export default Legend
